export default "__VITE_ASSET__DmHhggKq__"